/**
 * Shared configuration and utilities for MAS (Merchant Account Service) components.
 * Used by both MerchantAccountSpace and MASNotification components.
 */

// MFE Script URL - uses local proxy in development to avoid CORS issues
export const MFE_SCRIPT_URL =
  process.env.NODE_ENV === 'development'
    ? '/mfe-cdn/merchant-account-space/v0/latest.js'
    : 'https://ls-mfe-assets-cdn.lightspeed.app/merchant-account-space/v0/latest.js';

// Common configuration values
export const MAS_CONFIG = {
  productCode: 'lsr',
  entityType: 'subscription' as const,
  getBaseUrl: () => `${window.location.origin}/admin/subscription/mas-proxy`,
  getEntityId: () => (window.merchantos.session.getSystemCustomerID() || 0).toString(),
  getMasUiUrl: () => `${window.location.origin}/admin/index.html#subscription`,
};

// Base configuration interface shared by MAS components
export interface MASBaseConfig {
  baseUrl: string;
  productCode: string;
  entityType: 'subscription' | 'location';
  entityId: string;
  locale: string;
}

/**
 * Creates the base configuration object for MAS components.
 */
export const createMASBaseConfig = (locale: string): MASBaseConfig => ({
  baseUrl: MAS_CONFIG.getBaseUrl(),
  productCode: MAS_CONFIG.productCode,
  entityType: MAS_CONFIG.entityType,
  entityId: MAS_CONFIG.getEntityId(),
  locale,
});
